<footer>
  <span translate>General.Client.Name</span> - <span translate>General.Portail.Client</span> - v0.2
</footer>
